export enum SystemConfigTypeEnum {
  COMMERCIAL = 'COMMERCIAL',
  RESIDENTIAL = 'RESIDENTIAL',
  OTHERS = 'OTHERS',
  SUPPLY = 'SUPPLY',
  OVERLOAD = 'OVERLOAD',
}
